import authRoles from '../../../auth/authRoles';
import { Typography, Container, Button } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import Features from './Features';
import FeatureDetail from './FeatureDetail';
import { getFeatureBySlug } from './featuresData';

// Feature Not Found Component
function FeatureNotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-white flex items-center justify-center">
      <Container maxWidth="md">
        <div className="text-center">
          <Typography
            variant="h1"
            align="center"
            className="text-6xl font-extrabold text-gray-900 mb-4"
          >
            404
          </Typography>
          <Typography
            variant="h2"
            align="center"
            className="text-3xl font-bold text-gray-700 mb-6"
          >
            Feature Not Found
          </Typography>
          <Typography
            variant="body1"
            className="text-xl text-gray-600 mb-8 leading-relaxed"
          >
            The feature you're looking for doesn't exist or may have been moved.
          </Typography>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              component={Link}
              to="/features"
              variant="contained"
              size="large"
              className="bg-blue-600 hover:bg-blue-700 px-8 py-3.5 text-base font-bold"
            >
              View All Features
            </Button>
            <Button
              component={Link}
              to="/"
              variant="outlined"
              size="large"
              className="border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-3.5 text-base font-semibold"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}

const FeaturesConfig = {
  settings: {
    layout: {
      style: 'layoutMarketingV2',
      config: {
        header: {
          display: true
        },
        footer: {
          display: true
        }
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/features',
      element: <Features />,
    },
    {
      path: '/features/:slug',
      element: <FeatureDetailWrapper />,
    },
  ],
};

// Wrapper component to get feature data from slug
function FeatureDetailWrapper() {
  const { slug } = useParams();
  const feature = getFeatureBySlug(slug);
  
  if (!feature) {
    return <FeatureNotFound />;
  }
  
  return <FeatureDetail feature={feature} />;
}

export default FeaturesConfig;